import {
  getNodegroupList,
  getNodeDetail,
  addNodeRequest,
  delNodeRequest,
  getClusterHost,
  updateNodeDetailRequest,
  checkImportHost,
  addClusterHostRequest,
  delHostRequest,
  getBranchInfoRequest,
  getBranchHostRequest
} from '../api/api'
import { getUrl } from '../utils/global/geturl'


const state = {
  checkedInfo: {}, // 独立模块or集群模块勾选信息
  tabClickActiveInfo: '',
  checkNodeInfo: {}, // 勾选节点信息
  clusterHostMember: [],
  selectHosts: [], // 勾选的主机
  aloneClusterModDetail: '' // 显示或隐藏 独立模块，集群模块 的详情
}

const getters = {
  getCheckedInfo: state => state.checkedInfo,
  cacheTabActive: state => state.tabClickActiveInfo,
  checkNodeInfo: state => state.checkNodeInfo,
  getClusterHostMember: state => state.clusterHostMember,
  getSelectHosts: state => state.selectHosts,
  getAloneClusterDetail: state => state.aloneClusterModDetail
}


const mutations = {
  SET_ALONE_CLUSTER_DETAIL (state, info) {
    state.aloneClusterModDetail = info
  },
  SET_NODEGROUP_NODE_DETAIL (state, info) {
    state.checkedInfo = info
  },
  SET_TAB_CLICK_ACTIVE (state, name) {
    state.tabClickActiveInfo = name
  },
  UPDATE_NODEGROUP_NODE_DETAIL (state, info) {
    state.checkedInfo.children.push(info)
  },
  SET_NODE_INFO (state, info) {
    state.checkNodeInfo = info
  },
  SET_CLUSTER_HOST_MEMBER (state, info) {
    state.clusterHostMember = info
  },
  SET_SELECT_MEMBER_HOST (state, info) {
    state.selectHosts = info
  },
  DELETE_CLUSTER_MEMBER (state, index) {
    state.clusterHostMember.splice(index, 1)
  },
  SET_CLUSTER_NEW_MEMBER (state, response) {
    switch (response.code) {
      case 200:
        // 先保存导入前的主机列表
        response.data.detail.forEach(member => {
          state.clusterHostMember.unshift({
            hostname: member.hostname,
            ip: member.ip,
            state: 'online',
            cluster_uuid: state.checkedInfo.uuid,
            cpu_num: member.cpu_num,
            memory: member.memory,
            created_at: member.created_at,
            uuid: member.uuid,
            flag: true // 标记
          })
        })
        break
    }
  }
}

const actions = {
  // 显示 独立模块/集群模块 详情
  async showAloneClusterDetail ({ dispatch, commit }, params) {
    commit('SET_ALONE_CLUSTER_DETAIL', params)
  },
  // 加载产品线，并缓存
  async reloadDataMethod ({ dispatch, commit }, params) {
    let getNode = sessionStorage.getItem(params)
    if (getNode) {
      return JSON.parse(sessionStorage.getItem(params))
    }
    return getNodegroupList(params).then(response => {
      sessionStorage.setItem(params, JSON.stringify(response.data))
      return response.data
    })
  },
  // 缓存勾选的节点信息
  async cacheNodeDetail ({ commit }, params) {
    commit('SET_NODEGROUP_NODE_DETAIL', params)
  },
  // 缓存tab页面
  async cacheTabActiveMethod ({ commit }, params) {
    commit('SET_TAB_CLICK_ACTIVE', params)
  },
  // 节点详情, 并加载成员主机
  async reloadNodeDetailMethod ({ dispatch, commit }, params) {
    return getNodeDetail(params).then(response => {
      commit('SET_NODE_INFO', response ? response.data.detail[0] : {})
      dispatch('reloadClusterMember', {fid: params}).then(response => {
        commit('SET_CLUSTER_HOST_MEMBER', response.data.detail)
      })
    })
  },
  // 添加新节点
  async addNodeMethod ({ commit }, params) {
    return addNodeRequest(params).then(response => response)
  },
  // 修改缓存选中节点的内容
  async updateNodeDetail ({ dispatch, commit }, params) {
    commit('UPDATE_NODEGROUP_NODE_DETAIL', params)
    sessionStorage.removeItem(params.tag)
    dispatch('reloadDataMethod', params.tag).then((response) => {
      sessionStorage.setItem(params.tag, JSON.stringify(response))
    })
  },
  // 删除节点
  async deleteNodeMethod ({ dispatch, commit }, params) { // params [xx,xx]
    return delNodeRequest(params).then(response => {
      return response
    }).catch(err => {
      return err
    })
  },
  // 删除缓存节点
  async deleteNodeDetail ({ dispatch, commit }, params) { // params private /public
    sessionStorage.removeItem(params)
    dispatch('reloadDataMethod', params).then((response) => {
      sessionStorage.setItem(params, JSON.stringify(response))
    })
  },
  // 加载成员主机
  async reloadClusterMember ({ dispatch, commit }, params) { // params uuid
    return getClusterHost(getUrl(params)).then(response => response)
  },
  // 缓存主机表勾选的主机
  async cacheHostTabSelection ({ commit }, params) { // params []
    commit('SET_SELECT_MEMBER_HOST', params)
  },
  // 修改主机详情
  async updateNodeDetailMethod ({ commit }, params) { // params uuid
    return updateNodeDetailRequest(params).then(response => response)
  },
  // 导入主机【移除】操作
  async deleteClusterMemberOne ({ dispatch, commit }, params) { // params index
    commit('DELETE_CLUSTER_MEMBER', params)
  },
  // 检查导入主机
  async checkImportHostMethod ({ commit }, params) { // params uuid
    return checkImportHost(params).then(response => {
      commit('SET_CLUSTER_NEW_MEMBER', response)
      return response
    })
  },
  // 检查导入主机
  async createImportHostMethod ({ commit }, params) { // params uuid
    return addClusterHostRequest(params).then(response => response)
  },
  // 删除主机
  async deleteHostsMethod ({ dispatch, commit }, params) { // params {}
    return delHostRequest(params).then(response => response)
  },
  // 获取branch的信息
  async getBranchInfoMethod ({ dispatch, commit }, params) { // params {}
    return getBranchInfoRequest(params).then(response => response)
  },
  // 获取branch下的主机信息
  async getBranchHostMethod ({ dispatch, commit }, params) { // params {}
    return getBranchHostRequest(getUrl(params)).then(response => response)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/nodegroup.js